import { render, staticRenderFns } from "./MarqueeComponent.vue?vue&type=template&id=f112914a&"
import script from "./MarqueeComponent.vue?vue&type=script&lang=js&"
export * from "./MarqueeComponent.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeComponent.vue?vue&type=style&index=0&id=f112914a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports